import type { GodownStatus } from "./api";

/** Godown operational status shared across the consoles. Single source
 * of truth for the order (edit dropdown), the display label + summary
 * word, and the header/table pill colour class per status token. */
export const GODOWN_STATUS_ORDER: GodownStatus[] = [
  "setup",
  "filling",
  "filled",
];

export const GODOWN_STATUS_META: Record<
  GodownStatus,
  { label: string; short: string; tag: string }
> = {
  setup: { label: "In Setup", short: "in setup", tag: "tag-setup" },
  filling: { label: "Filling", short: "filling", tag: "tag-live" },
  filled: { label: "Filled", short: "filled", tag: "tag-off" },
};

/** Normalize a possibly-missing status to a known token. */
export function godownStatusOf(
  g: { status?: GodownStatus | null },
): GodownStatus {
  const s = g.status ?? "setup";
  return s in GODOWN_STATUS_META ? s : "setup";
}

/** The status pill used in godown headers and the district table. */
export function StatusTag({ status }: { status: GodownStatus }) {
  const meta = GODOWN_STATUS_META[status] ?? GODOWN_STATUS_META.setup;
  return (
    <span className={"tag " + meta.tag}>
      <span className="dot" />
      {meta.label}
    </span>
  );
}
